import React from 'react';
import {
  ExtensionSlot,
} from 'piral-core';

// Helper function to render multiple extension slots
const renderSlots = (baseName, props, maxSlots = 10) => {
  const slots = [];

  // Render numbered slots (e.g., "slot-1", "slot-2", etc.)
  for (let i = 1; i <= maxSlots; i++) {
    slots.push(
      <div key={`${baseName}-${i}`} style={{ flex: 1, minWidth: 0, overflowY: 'auto' }}>
        <ExtensionSlot name={`${baseName}-${i}`} params={props} />
      </div>
    );
  }

  return slots;
};

/**
 * Horizontal Layout Component (Row Layout)
 * 
 * This layout arranges content horizontally side-by-side.
 * Each slot takes equal width (flex: 1) and full height.
 * 
 * AVAILABLE EXTENSION SLOTS:
 * - "slot-1", "slot-2", "slot-3", ... up to "slot-10"
 * 
 * USE CASE:
 * - Dashboards with side-by-side panels
 * - Comparison views
 * - Multi-column content
 * - Split views
 */
export default {
  Layout: (props) => {
    const { pageKey, ...otherProps } = props;
    const prefix = `${pageKey || ''}-`;

    return (
      <div style={{
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        display: 'flex',
        flexDirection: 'row',
        height: '100vh',
        width: '100%',
        overflow: 'hidden'
      }}>
        {renderSlots(`${prefix}slot`, otherProps)}
      </div>
    );
  },
}
